import intialState from './DashboardInitialState';
import reducers from './DashBoardReducer';

export default {
  intialState,
  reducers,
};
